module.exports = __webpack_public_path__ + "img/news_post_4.fe3b7e1a.png";